/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    QSI: any;
  }
}
import { useMutation } from 'react-query';
import CryptoJS from 'crypto-js';
import { wqkgx } from '../../config/keys';
import { itemCheck } from '../../assets/images/dashboard-business';
import { cancel, eyes, hr } from '../../assets/images/login';
import styles from './loginForm.module.css';
import axios, { AxiosError } from 'axios';
import OtpModal from '../../components/global/OtpModal';
import { toast } from 'react-toastify';
import { baseUrl_, timeout } from '../../utils/constants';
import SuccessModal from '../../components/global/SuccessModal';
import { useAppDispatch } from '../../app/hooks';
import { setCategory, setYearsInBusiness } from '../formAfterSignUp/formAfterSignUpSlice';
import { handleError } from '../../utils/errorHandler';
import { decryptJson } from '../../utils/decryptJson';
import { encryptData } from '../../utils/encryptJson';
import { registerNetcoreActivity } from '../../utils/registerActivity';
import ReactGA from 'react-ga4';
import { containsSpecialChars } from '../../utils/validations';
import customToast, { ToastType } from '../../components_/Toast';
import { Request } from '../../apis/request';
// import useQualtricsIntercept from '../../hooks/useQualtricsIntercept';

type TRegistrationProps = {
  firstName: string;
  lastName: string;
  email: string;
  daoCode: string;
  country: string;
  phoneNumber: string;
  heardAboutUs: string;
  password?: string;
};

type Tprops = {
  registrationDetails: TRegistrationProps;
  onCreatePassword: React.Dispatch<React.SetStateAction<boolean>>;
};

const CreatePassword = ({ registrationDetails, onCreatePassword }: Tprops) => {
  const [seePassword, setSeePassword] = useState(false);
  const [seeConfirmPassword, setSeeConfirmPassword] = useState(false);
  const [isMorethan8, setIsMorethan8] = useState(false);
  const [isLessThan24, setIsLessThan24] = useState(false);
  const [oneCapital, setOneCapital] = useState(false);
  const [oneLower, setOneLower] = useState(false);
  const [oneSymbol, setOneSymbol] = useState(false);
  const [oneNumber, setOneNumber] = useState(false);
  const [encryptedPassword, setsetEncryptedPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [tokenSent, setTokenSent] = useState(false);
  // useQualtricsIntercept();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const brandId = 'sterlingbank'; // Your Qualtrics brand ID
  const projectId = 'ZN_2z6WIQ0mKpJtVbA'; // Your Qualtrics project ID
  const interceptId = 'SI_0vSIFoibq6OGNM2'; // Your Intercept ID
  const surveyUrl = `https://${brandId}.qualtrics.com/jfe/form/${projectId}`;

  const [token, setToken] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    if (encryptedPassword.length >= 8) {
      setIsMorethan8(true);
    } else {
      setIsMorethan8(false);
    }

    if (encryptedPassword.length >= 8 && encryptedPassword.length <= 25) {
      setIsLessThan24(true);
    } else {
      setIsLessThan24(false);
    }

    if (encryptedPassword.search(/[A-Z]/) >= 0) {
      setOneCapital(true);
    } else {
      setOneCapital(false);
    }
    if (encryptedPassword.search(/[a-z]/) >= 0) {
      setOneLower(true);
    } else {
      setOneLower(false);
    }

    if (encryptedPassword.search(/[0-9]/) >= 0) {
      setOneNumber(true);
    } else {
      setOneNumber(false);
    }

    if (containsSpecialChars(encryptedPassword)) {
      setOneSymbol(true);
    } else {
      setOneSymbol(false);
    }
  }, [encryptedPassword, confirmPassword]);

  useEffect(() => {
    if (
      oneCapital &&
      oneLower &&
      oneSymbol &&
      oneNumber &&
      isMorethan8 &&
      isLessThan24 &&
      encryptedPassword === confirmPassword
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [
    oneCapital,
    oneLower,
    oneSymbol,
    oneNumber,
    isMorethan8,
    isLessThan24,
    encryptedPassword,
    confirmPassword,
  ]);

  // COMMENTING OUT PHONE VERIFICATION //---
  // const onGetTokenSuccessFul = () => {
  //   setTokenSent(true);
  // };

  // const { getTokenApi } = useGetToken({ onGetTokenSuccess: onGetTokenSuccessFul });

  const password = CryptoJS.AES.encrypt(encryptedPassword, wqkgx).toString();

  const showErrorToastMessage = (error: string) => {
    customToast(error, ToastType.error, '', 6000);
    onCreatePassword(false);
  };

  const errorFn = (error: AxiosError<{ status: number }>) => {
    error?.response?.data?.status === 409
      ? showErrorToastMessage('Email has already been registered')
      : error?.response?.data?.status === 422
      ? showErrorToastMessage('Invalid phone number or email')
      : showErrorToastMessage('Something went wrong, please try again');
  };

  const signinUpUser = useMutation(
    (data: TRegistrationProps) =>
      Request.post(`/auth/signup`, encryptData(data), {
        headers: {
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      }),
    {
      onSuccess: async (data) => {
        const res = decryptJson(data?.data?.data);
        setToken(res?.token);
        setTokenSent(true);
        localStorage.setItem('signup-token', res?.token);
        localStorage.setItem('token-for-phone-otp', res?.token);
        localStorage.setItem('signup-email', res?.email?.toLowerCase());
        localStorage.removeItem('login-token');
      },
      onError: async (error: AxiosError<{ status: number }>) => {
        handleError({ error, errorFn });
      },
    },
  );
  const signUpFn = (data: TRegistrationProps) => {
    signinUpUser.mutate(data);
  };

  const onclickSignup = (data: TRegistrationProps) => {
    !disabled && !signinUpUser.isLoading && signUpFn(data);
    registerNetcoreActivity(
      {
        emailAddress: registrationDetails && registrationDetails.email,
        firstName: registrationDetails.firstName && registrationDetails.firstName,
        lastName: registrationDetails.lastName && registrationDetails.lastName,
        mobileNumber: registrationDetails.phoneNumber && registrationDetails.phoneNumber,
      },
      'TBH_SIGN_UP_SUCCESSFUL',
    );

    registerNetcoreActivity(
      {
        emailAddress: registrationDetails && registrationDetails.email,
        firstName: registrationDetails.firstName && registrationDetails.firstName,
        lastName: registrationDetails.lastName && registrationDetails.lastName,
        mobileNumber: registrationDetails.phoneNumber && registrationDetails.phoneNumber,
      },
      'Completed Sign Up',
    );
    ReactGA.event({
      category: 'Button',
      action: 'TBH_SIGN_UP_SUCCESSFUL',
      label: 'TBH_SIGN_UP_SUCCESSFUL',
      // value: 1
    });
  };

  useEffect(() => {
    const keyDownHandler = (event: { key: string; preventDefault: () => void }) => {
      if (event.key === 'Enter') {
        event.preventDefault();

        // 👇️ call submit function here
        onclickSignup({
          ...registrationDetails,
          password,
        });
        setDisabled(true);
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [registrationDetails, onclickSignup, password]);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setYearsInBusiness(''));
    dispatch(setCategory(''));
  }, [dispatch]);

  return (
    <div className={`${styles.formContainer}  md:w-[37%]`}>
      <div className='mb-3'>
        <h3 className={styles.loginText}>Set your password</h3>
        <img src={hr} alt='hr.png' />
      </div>

      <div className='relative mt-2'>
        <input
          placeholder='Password'
          onChange={(e) => setsetEncryptedPassword(e.target.value)}
          className={styles.createPasswordInput}
          type={!seePassword ? 'password' : 'text'}
        />
        <img
          src={eyes}
          className='absolute bottom-4 right-6 cursor-pointer'
          alt='see_password.png'
          onClick={() => {
            setSeePassword(!seePassword);
          }}
        />
      </div>

      <div className='relative mt-2 mb-6'>
        <input
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder='Confirm Password'
          className={styles.createPasswordInput}
          type={!seeConfirmPassword ? 'password' : 'text'}
        />
        <img
          src={eyes}
          alt='see_password.png'
          className='absolute bottom-4 right-6 cursor-pointer'
          onClick={() => {
            setSeeConfirmPassword(!seeConfirmPassword);
          }}
        />
      </div>

      <div className='mt-[3rem]'>
        <div
          className={`flex gap-2 mb-2 text-xs ${disabled ? 'text-errorRed' : 'text-successGreen'}`}
        >
          <img src={!disabled ? itemCheck : cancel} alt='check.png' />
          <p>
            {disabled
              ? 'passwords must match before you can continue'
              : 'we have a password match!'}
          </p>
        </div>

        <div
          className={[
            'flex gap-2 mb-2 text-xs',
            isMorethan8 ? 'text-[#049E26]' : 'text-[#F51010]',
          ].join(' ')}
        >
          <img src={isMorethan8 ? itemCheck : cancel} alt='check.png' />
          <p>Minimum of eight charaters</p>
        </div>
        <div
          className={[
            'flex gap-2 mb-2 text-xs',
            isLessThan24 ? 'text-[#049E26]' : 'text-[#F51010]',
          ].join(' ')}
        >
          <img src={isLessThan24 ? itemCheck : cancel} alt='check.png' />
          <p>Maximum of 24 charaters</p>
        </div>
        <div
          className={[
            'flex gap-2 mb-2 text-xs',
            oneCapital ? 'text-[#049E26]' : 'text-[#F51010]',
          ].join(' ')}
        >
          <img src={oneCapital ? itemCheck : cancel} alt='check.png' />
          <p>Atleast one uppercase letter</p>
        </div>
        <div
          className={[
            'flex gap-2 mb-2 text-xs',
            oneLower ? 'text-[#049E26]' : 'text-[#F51010]',
          ].join(' ')}
        >
          <img src={oneLower ? itemCheck : cancel} alt='check.png' />
          <p>Atleast one lowercase letter</p>
        </div>
        <div
          className={[
            'flex gap-2 mb-2 text-xs',
            oneSymbol ? 'text-[#049E26]' : 'text-[#F51010]',
          ].join(' ')}
        >
          <img src={oneSymbol ? itemCheck : cancel} alt='check.png' />
          <p>Atleast one symbol (@#%%$^*^)</p>
        </div>
        <div
          className={[
            'flex gap-2 mb-2 text-xs',
            oneNumber ? 'text-[#049E26]' : 'text-[#F51010]',
          ].join(' ')}
        >
          <img src={oneNumber ? itemCheck : cancel} alt='check.png' />
          <p>Atleast one number</p>
        </div>
      </div>

      <div className='flex justify-center mt-[40px] gap-2 flex-wrap'>
        <button
          onClick={() => onCreatePassword(false)}
          className={[
            'bg-black',
            'w-[100%] rounded-[6px] text-center text-[#FFFFFF] p-2 mb-0',
          ].join(' ')}
        >
          {'Go Back'}
        </button>
        <button
          onClick={() =>
            onclickSignup({
              ...registrationDetails,
              password,
            })
          }
          className={[
            disabled ? 'bg-[grey]' : 'bg-[#229698]',
            'w-[100%] text-center text-[#FFFFFF] p-2 mb-0 rounded-[6px]',
          ].join(' ')}
        >
          {signinUpUser.isLoading ? 'Submitting...' : 'Submit'}
        </button>
      </div>

      <OtpModal
        phoneNumber={registrationDetails.phoneNumber}
        showModal={tokenSent}
        setShowModal={setTokenSent}
        pageComingFrom={'Signup'}
        setShowSuccessModal={setShowSuccessModal}
      />

      <SuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
        pageComingFrom={'Signup'}
        closePreviousModal={() => setTokenSent(false)}
        whereTo={'/set-security-questions'}
      />
    </div>
  );
};

export default CreatePassword;
